import { m } from '@hub/messages';
import { definePageRoute } from '@hub/router/definePageRoute';
import { type DomainParents, defineDomainRoutes } from '@hub/router/domain-routes';
import { getSubscriptionOptions } from '@platform/api';
import { HomeNetworkPaths } from './route.paths';
import { getHomeNetworkStatusQueryOptions } from './useHomeNetworkStatus';

export default function createHomeNetworkRoutes(parents: DomainParents) {
  const overviewRoute = definePageRoute(parents, {
    path: HomeNetworkPaths.overview,
    title: m.home_network_page_title,
    description: m.home_network_page_description,
    page: () => import('./HomeNetwork.page'),
    flag: 'page-home-network',
    pendingComponent: () => import('./components/HomeNetworkSkeleton'),
    loader: ({ context }) => {
      context.queryClient.prefetchQuery(getHomeNetworkStatusQueryOptions());
      context.queryClient.prefetchQuery(getSubscriptionOptions());
    },
    quickAction: {
      to: HomeNetworkPaths.overview.path,
      icon: 'home',
      title: m.home_network_quick_action_title,
      subline: m.home_network_quick_action_subline,
      surfaces: ['home-account'],
      order: 45,
    },
  });

  return defineDomainRoutes({
    authenticated: [overviewRoute] as const,
    public: [] as const,
  });
}
